import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/sharp-regular-svg-icons'
import { Button, Menu } from '@mantine/core'
import React from 'react'

import { use1080pOrLess } from '../../../DefaultPaginatedTableImplementation/use1080pOrLess'
import type { DefaultSelectionActionButtonProps } from '../selection-footer'

const DefaultSelectionActionButton = ({
  buttonProps = {
    size: 'xs',
  },
  menuProps = {
    width: 'target',
  },
  selectedItemCount,
  children,
}: DefaultSelectionActionButtonProps): React.ReactElement => {
  const countLabel =
    selectedItemCount === 1
      ? i18n.t('one_selected_element_table', {
          defaultValue: '1 Element ausgewählt',
        })
      : i18n.t('n_selected_element_table', {
          defaultValue: '{{selectedItemCount}} Elemente ausgewählt',
          selectedItemCount,
        })

  const is1080pOrLess = use1080pOrLess()
  return (
    <Menu {...menuProps}>
      <Menu.Target>
        <Button
          size={is1080pOrLess ? 'xs' : 'sm'}
          compact={is1080pOrLess}
          rightIcon={<FontAwesomeIcon icon={faChevronDown} />}
          {...buttonProps}
          disabled={selectedItemCount === 0}
        >
          {countLabel}

          {/* {t('selectedElementsWithCount', { count: selectedItemCount })} */}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{countLabel}</Menu.Label>
        {children}
      </Menu.Dropdown>
    </Menu>
  )
}

export default DefaultSelectionActionButton
